import React from 'react';

import Image from '../../../../library/image/image';
import Typography from '../../../../library/typography/typography';

import './easy-pay-options.scss';

function EasyPayOptions() {
  if (
    process.env.__FF_AFFIRM_PAY_CHECKOUT__ !== 'true' &&
    process.env.__FF_APPLE_PAY_CHECKOUT__ !== 'true' &&
    process.env.__FF_GOOGLE_PAY_CHECKOUT__ !== 'true' &&
    process.env.__FF_PAYPAL_CHECKOUT__ !== 'true'
  ) {
    return null;
  }

  return (
    <aside styleName="container">
      <Typography styleName="title" tag="span" weight="bold">
        Easy Pay Options
      </Typography>
      {process.env.__FF_AFFIRM_PAY_CHECKOUT__ === 'true' && (
        <Image
          alt="affirm logo"
          loading="lazy"
          src="https://discounttire.scene7.com/is/content/discounttire/logos/Affirm-Logo.svg"
          styleName="payment-logo affirm-logo"
        />
      )}
      {process.env.__FF_PAYPAL_CHECKOUT__ === 'true' && (
        <Image
          alt="paypal logo"
          loading="lazy"
          src="https://discounttire.scene7.com/is/content/discounttire/logos/badges/paypal-logo.svg"
          styleName="payment-logo"
        />
      )}
      {process.env.__FF_APPLE_PAY_CHECKOUT__ === 'true' && (
        <Image
          alt="apple pay logo"
          loading="lazy"
          src="https://discounttire.scene7.com/is/content/discounttire/discounttire/customerservice/payments/Apple_Pay.svg"
          styleName="payment-logo"
        />
      )}
      {process.env.__FF_GOOGLE_PAY_CHECKOUT__ === 'true' && (
        <Image
          alt="google pay logo"
          loading="lazy"
          src="https://discounttire.scene7.com/is/content/discounttire/logos/badges/google-pay.svg"
          styleName="payment-logo"
        />
      )}
    </aside>
  );
}

export default EasyPayOptions;
